/* eslint-disable max-statements */
import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import Modal from "../../shared/modal";
import CloseButton from "../../shared/icon-cross";
import CarPriceGuideCard from "../car-price-guide-card";
const CarPriceGuideCardModal = ({ isOpen, onClose,  priceScale, egc = 0 }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div styleName={"styles.modalWrap"}>
                <div styleName={"styles.modalHeaderWrap"}>
                    <div styleName={"styles.modalHeader"}>
                        <h4>Deals that make you go "Crikey!"</h4>
                        <span styleName={"styles.close"}>
                            <CloseButton onClickHandler={onClose} type="modalClose" />
                        </span>
                    </div>
                </div>
                <div styleName={"styles.scaleWrapper"}>
                    <CarPriceGuideCard
                        isModal={true}
                        priceScale={priceScale}
                        egc={egc}
                    />
                </div>

            </div>
        </Modal>
    );
};

CarPriceGuideCardModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    priceScale: PropTypes.object,
    egc: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default CarPriceGuideCardModal;
